import * as types from './actionTypes';

export function dispatchActionData(type, data) {
	return { type: type, data: data };
}

export function csvUploadMissingProducts(productIVMs) {
	return function (dispatch) {
		dispatch(dispatchActionData(types.CSV_IMPORT_MISSING_IVMS, productIVMs));
	};
}
